import Vue from 'vue'
import MfaEmailDialog from './MfaEmailDialog.vue'

// Segunda etapa do login. Quando a API responde mfaRequired (código enviado por e-mail, sem
// tokens), abre o diálogo do código e só resolve com a resposta final (tokens ou erro) depois
// que AccessToken/Mfa valida o código com as mesmas credenciais.
// Fica no controller de autenticação para valer em todas as telas de login, inclusive a do
// @bmp-vue/core, sem alterar cada uma. Cancelar rejeita a promise (as telas só logam o erro).
export function ResolverMfa (resposta, { validar, reenviar }) {
  if (!resposta || !resposta.mfaRequired) {
    return Promise.resolve(resposta)
  }

  return new Promise((resolve, reject) => {
    const host = document.querySelector('[data-app]') || document.body
    const root = host.__vue__ ? host.__vue__.$root : undefined
    const Dialog = Vue.extend(MfaEmailDialog)
    const vm = new Dialog({
      parent: root,
      propsData: { mfa: resposta, validar, reenviar },
    })

    const encerrar = () => {
      vm.$destroy()
      if (vm.$el && vm.$el.parentNode) {
        vm.$el.parentNode.removeChild(vm.$el)
      }
    }

    vm.$on('concluido', (data) => {
      encerrar()
      resolve(data)
    })
    vm.$on('cancelado', () => {
      encerrar()
      reject(new Error('Verificação em duas etapas cancelada'))
    })

    vm.$mount()
    host.appendChild(vm.$el)
  })
}

// Registro explícito no main.js (Vue.use(mfa)). O controller de autenticação continua importando
// ResolverMfa diretamente, então o MFA funciona mesmo sem este registro.
export default {
  install (VueInstance) {
    VueInstance.prototype.$resolverMfa = ResolverMfa
  },
}
